<template>
  <HeaderNotify>
    <div v-if="isVrio" class="color-blue">
      Вы работаете под учетной записью @{{ me?.username }}. Для возврата в свою
      УЗ необходимо
      <button class="btn-reset btn-link" @click="handleLogout">
        авторизоваться
      </button>
    </div>
    <div v-else-if="me?.vrio?.length" class="color-red">
      Вы назначены как ВРИО
      <button class="btn-reset btn-link" @click="onOpenProxyModal">
        Подробнее
      </button>
    </div>
  </HeaderNotify>
  <header class="header">
    <HeaderNav v-if="me?.roles" :roles="me.roles" />
    <div class="header-person">
      <button @click="isMenuShow = !isMenuShow">
        <img src="@/assets/img/person.svg" />
        {{ me?.name }}
      </button>
      <Dropdown v-if="isMenuShow" @close="isMenuShow = false">
        <li v-if="!isAdmin">
          <button @click="onOpenProxyModal">Установить заместителя</button>
        </li>
        <li>
          <button @click="onChangePassword">Сменить пароль</button>
        </li>
        <li>
          <button type="button" @click="handleLogout">Выйти</button>
        </li>
      </Dropdown>
    </div>
    <div class="header-row">
      <span v-if="me?.username">
        Username: <strong>{{ me.username }}</strong>
      </span>
    </div>
  </header>
  <ProxyListModal v-if="isProxyModalShow" @close="isProxyModalShow = false" />
</template>

<script setup>
import { ref, computed } from 'vue'
import Dropdown from '@/components/Dropdown.vue'
import ProxyListModal from '@/components/modals/ProxyListModal.vue'
import HeaderNotify from '@/components/HeaderNotify.vue'
import HeaderNav from '@/components/HeaderNav.vue'
import useAuth from '@/utils/useAuth'

const emit = defineEmits(['change-password'])
const { isVrio, logout, me } = useAuth()

const isProxyModalShow = ref(false)
const isMenuShow = ref(false)

const isAdmin = computed(() =>
  me.value?.roles?.some((r) => ['adminsales', 'admintrade'].includes(r))
)

const onChangePassword = () => {
  isMenuShow.value = false
  emit('change-password')
}

const handleLogout = async () => {
  isMenuShow.value = false
  logout()
}

const onOpenProxyModal = () => {
  isMenuShow.value = false
  isProxyModalShow.value = true
}
</script>

<style lang="scss" scoped>
.header {
  // height: 95px;
  // border-bottom: 1px solid #d2d2d2;
  // margin: 0px 15px;
  // font-size: 10px;
  // gap: 16px;
  // line-height: 1.2;
  // @include mobile {
  //   height: 63px;
  // }
  border-bottom: 1px solid #d2d2d2;
  display: flex;
  flex-wrap: wrap;
  padding: 16px;
  justify-content: flex-end;
  gap: 8px 16px;
  font-size: 12px;
  line-height: 1.2;
  @include mobile {
    gap: 8px;
  }
  &-person {
    gap: 6px;
    font-weight: 700;
    position: relative;
    &:deep() button {
      @include reset-button;
      font-size: inherit;
      line-height: inherit;
      img {
        max-width: 24px;
        max-height: 24px;
        vertical-align: middle;
      }
    }
  }
  &-row {
    width: 100%;
    display: flex;
    gap: 16px;
    align-items: top;
    justify-content: flex-end;
    @include mobile {
      gap: 8px;
    }
  }
}
</style>
